import { render, staticRenderFns } from "./AtaMsgModal.vue?vue&type=template&id=945d5ed8&scoped=true"
import script from "./AtaMsgModal.vue?vue&type=script&lang=js"
export * from "./AtaMsgModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "945d5ed8",
  null
  
)

export default component.exports